import classnames from "classnames";

import infoIcon from 'apps/QuoterApp/assets/images/Info Icon.svg';

import 'shared/components/Hint/styles.scss';

function Hint({title, children, className}) {
    return <div className={classnames("Hint", className)}>
        <img src={infoIcon} alt={"i"}/>
        <div className={"Hint__Data"}>
            {title && <div className={"Hint__Data__Title"}>{title}</div>}
            <div className={"Hint__Data__Text"}>
                {children}
            </div>
        </div>
    </div>;
}

export default Hint;
